// ============================================================================
// ponto.js — helpers do ponto eletrônico (jornada, regime, elegibilidade)
// ============================================================================

export const WEEKDAYS = [
  { key: 'mon', label: 'Seg' },
  { key: 'tue', label: 'Ter' },
  { key: 'wed', label: 'Qua' },
  { key: 'thu', label: 'Qui' },
  { key: 'fri', label: 'Sex' },
  { key: 'sat', label: 'Sáb' },
  { key: 'sun', label: 'Dom' },
];

export const WEEKLY_HOUR_PRESETS = [30, 36, 40, 44];

// Cargos PJ — NÃO entram no ponto (prestadores, não CLT)
const PJ_ROLE_KEYWORDS = ['barbeiro', 'manicure', 'esteticista', 'visagista'];

export function normalize(s) {
  return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
}

// Mapa: contractType da folha (uppercase) → regime do ponto + regras CLT
//   JOVEM APRENDIZ / ESTAGIO → sem hora extra nem banco
//   PJ → não elegível ao ponto
export const CONTRACT_PONTO_MAP = {
  'CLT':            { value: 'clt',            label: 'CLT',            overtime: true,  bank: true,  eligible: true },
  'JOVEM APRENDIZ': { value: 'jovem_aprendiz', label: 'Jovem Aprendiz', overtime: false, bank: false, eligible: true },
  'REGISTRAR':      { value: 'registrar',      label: 'A Registrar',    overtime: true,  bank: true,  eligible: true },
  'ESTAGIO':        { value: 'estagiario',     label: 'Estagiário',     overtime: false, bank: false, eligible: true },
  'PJ':             { value: 'pj',             label: 'PJ',             overtime: false, bank: false, eligible: false },
};

export function contractMeta(contractType) {
  return CONTRACT_PONTO_MAP[contractType] || CONTRACT_PONTO_MAP['CLT'];
}

// Elegível ao ponto: NÃO é PJ (nem por cargo, nem por tipo de contrato)
export function isPontoEligible(prof) {
  if (!prof) return false;
  if (prof.contractType === 'PJ') return false;
  const role = normalize(prof.role);
  // Sócio é sócio/investidor: não tem jornada nem bate ponto.
  if (role.includes('socio')) return false;
  if (PJ_ROLE_KEYWORDS.some(kw => role.includes(kw))) return false;
  return true;
}

// Gerente entra como jornada flexível por padrão
export function isGerente(prof) {
  return normalize(prof?.role).includes('gerente');
}

// Template padrão: Seg-Sex 9-18 (almoço 13-14), Sáb 9-13
export function defaultJourney() {
  const work = { works: true, shifts: [{ start: '09:00', end: '13:00' }, { start: '14:00', end: '18:00' }] };
  const sat = { works: true, shifts: [{ start: '09:00', end: '13:00' }] };
  const off = { works: false, shifts: [] };
  return { mon: { ...work }, tue: { ...work }, wed: { ...work }, thu: { ...work }, fri: { ...work }, sat, sun: off };
}

export function journeyWeeklyHours(journey) {
  let min = 0;
  for (const d of WEEKDAYS) {
    const day = journey?.[d.key];
    if (!day?.works) continue;
    for (const s of (day.shifts || [])) {
      const [sh, sm] = String(s.start || '0:0').split(':').map(Number);
      const [eh, em] = String(s.end || '0:0').split(':').map(Number);
      const m = (eh * 60 + em) - (sh * 60 + sm);
      if (m > 0) min += m;
    }
  }
  return Math.round((min / 60) * 10) / 10;
}

// Config de ponto default pra um profissional novo
export function defaultPontoConfig(prof) {
  return {
    scheduleMode: isGerente(prof) ? 'flexible' : 'fixed',
    contractWeeklyHours: 44,
    journey: defaultJourney(),
    gpsRequired: true,
    gpsRadiusM: 200,
  };
}
